import { Link } from "react-router-dom";
import { ROUTES } from "@routing/routes";
import type { CategoryChipData } from "@models/category";

interface CategoryChipProps {
    category: CategoryChipData;
}

export const CategoryChip = ({ category }: CategoryChipProps) => {
    // A leaf named only by weight is told apart by its parent (B-01).
    const label = category.parentName
        ? `${category.parentName} · ${category.name}`
        : category.name;

    return (
        <Link
            to={ROUTES.BROWSE_CATEGORY(category.id)}
            aria-label={label}
            className="flex flex-col items-center gap-2 w-20 shrink-0"
        >
            <div className="w-16 h-16 rounded-full bg-base-300 flex items-center justify-center overflow-hidden">
                <span aria-hidden="true" className="text-base-content/40">
                    {category.name.charAt(0)}
                </span>
            </div>
            {/* Two lines: one would clip a long parent's label before the
                leaf name that tells two chips apart. */}
            <span className="text-xs text-center text-neutral line-clamp-2">
                {label}
            </span>
        </Link>
    );
};
